export default __webpack_public_path__ + "static/media/Mastercards.22fc9fb4.svg";